import { FC, SVGAttributes } from "react";

const CheckSmall: FC<SVGAttributes<SVGSVGElement>> = ({
  height = "16px",
  width = "16px",
  fill = "#000",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3327 5L5.99935 12.3333L2.66602 9"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { CheckSmall };
